import PropTypes from 'prop-types';
import React from 'react';

import BackButton from '@/components/BackButton';
import Breadcrumbs, { Breadcrumb } from '@/components/Breadcrumbs';
import LazyEditForm from '@/components/LazyEditForm';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PaperSheet from '@/components/PaperSheet';
import KkmNameLazy from '@/containers/KkmNameLazy';
import { createKkmPageUrl } from '@/features/kkmPage/utils';
import { ROUTE_PATH as KKMS_PATH } from '@/features/kkmsPage/consts';

import Form from './Form';

const PageEditKkm = ({
  fetchItem,
  getItemLoadingError,
  isItemLoaded,
  isItemLoading,
  kkmId,
  updateKkm,
}) => (
  <Page>
    <PageHeader gutterBottom={false} xl={8}>
      <Breadcrumbs>
        <Breadcrumb to={KKMS_PATH}>Справочник ККМ</Breadcrumb>
        <Breadcrumb to={createKkmPageUrl(kkmId)}>
          <KkmNameLazy kkmId={kkmId} />
        </Breadcrumb>
      </Breadcrumbs>
      <BackButton />
      <PageTitle>Редактирование ККМ</PageTitle>
    </PageHeader>
    <PageContent xl={8}>
      <PaperSheet>
        <LazyEditForm
          fetchItem={fetchItem}
          getItemLoadingError={getItemLoadingError}
          isItemLoaded={isItemLoaded}
          isItemLoading={isItemLoading}
          itemId={kkmId}
        >
          <Form kkmId={kkmId} onSubmit={updateKkm} />
        </LazyEditForm>
      </PaperSheet>
    </PageContent>
  </Page>
);

PageEditKkm.propTypes = {
  fetchItem: PropTypes.func.isRequired,
  getItemLoadingError: PropTypes.func.isRequired,
  isItemLoaded: PropTypes.func.isRequired,
  isItemLoading: PropTypes.func.isRequired,
  updateKkm: PropTypes.func.isRequired,
  kkmId: PropTypes.any.isRequired,
};

export default PageEditKkm;
